import { useEffect, useState } from "react";
import axios from "axios";

import {
  formatCalendarDate,
  formatDate,
  formatPhoneNumber,
  getAge,
  getToken,
} from "../../../Utils/helper";
import LeadPopup from "../../FirmSettings/new-lead-sources/identified-leads/modals/lead-popup";
import PendingPopup from "../../FirmSettings/new-lead-sources/identified-leads/modals/pending-popup";
import incidentIcon from "../../../assets/images/incident.svg";
import birthdayIcon from "../../../assets/images/birthdayicon.svg";
import LeadWebSocketManager from "../../../Utils/lead-socket-manager";

const IncomingLeads = ({ setActiveTab, setSubActiveTab, fetchPendingData }) => {
  const [data, setData] = useState([]);
  const [editData, setEditData] = useState();
  const [showLeadModal, setShowLeadModal] = useState(false);
  const [showPendingModal, setShowPendingModal] = useState(false);

  const [pendingMessage, setPendingMessage] = useState("");
  const [pendingUser, setPendingUser] = useState(null);
  const [variableOrder, setVariableOrder] = useState([]);

  const handleShowModal = (data) => {
    // PendingLead
    fetchPendingLead(data);
  };
  const handleCloseModal = () => setShowLeadModal(false);
  const handleCloseModalPending = () => setShowPendingModal(false);

  const origin = process.env.REACT_APP_BACKEND_URL;

  const fetchPendingLead = async (row) => {
    try {
      const response = await axios.get(
        `${origin}/api/firmsetting-page/edit-lead/?lead_id=${row.id}`,
        {
          headers: {
            Authorization: getToken(),
          },
        }
      );
      if (response.status === 200) {
        const leadData = response.data?.data;
        const currentUserId = parseInt(localStorage.getItem("loggedInUser"));

        // has_pending_lead is true
        if (leadData.has_pending_lead) {
          if (leadData.status?.name === "Pending" && leadData.updated_by?.id === currentUserId) {
            setEditData(row);
            setShowLeadModal(true);
            return;
          } else {
            setPendingMessage(
              "You are already working on a lead. Please complete or close it before opening another."
            );
            setShowPendingModal(true);
            return;
          }
        }

        // status is Pending
        if (leadData.status?.name === "Pending") {
          if (leadData.updated_by?.id === currentUserId) {
            setEditData(row);
            setShowLeadModal(true);
          } else {
            setEditData(row);
            setPendingUser(leadData.updated_by);
            setPendingMessage(
              "Update"
              // The status on this lead is pending because ${leadData.updated_by.first_name} ${leadData.updated_by.last_name} is processing an intake. Do you wish to cancel the processing of the intake and begin your own intake?
            );
            setShowPendingModal(true);
          }
          return;
        }

        // Other than
        setEditData(row);
        setShowLeadModal(true);
      } else {
        throw new Error("Failed to fetch data: Unexpected status code");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchData = async () => {
    try {
      const response = await axios.get(`${origin}/api/firmsetting-page/leads/`, {
        headers: {
          Authorization: getToken(),
        },
      });
      if (response.status === 200) {
        const result = response.data;
        setData(result.data);
        setVariableOrder(result.variable_order || []);
      } else {
        throw new Error("Failed to fetch data: Unexpected status code");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();

    const token = getToken().slice(7); // remove "Bearer " part if needed

    // Connect to WebSocket
    LeadWebSocketManager.connect(token);

    // 🔔 Set listener for new messages
    LeadWebSocketManager.setOnMessage(() => {
      fetchData();
    });

    // Disconnect on unmount (important!)
    return () => {
      LeadWebSocketManager.disconnect();
    };
  }, []);

  return (
    <>
      <table
        className="table table-borderless table-striped table-earning has-height-25 fixed-table-header-notes-page"
        id="table-x"
      >
        <thead className="toolbar-fonts">
          <tr id="tb-header">
            <th className="width-notes-custom" scope="col" />
            <th className="note-col-2 x2 text-center">Name</th>
            <th className="note-col-3 x2 text-center">Date</th>
            <th className="note-col-3 x2 text-center">Subject</th>
            <th className="notes-col note-col-5 x5 text-center">Text</th>
            <th className="notes-col note-col-5 x5 text-center">Identified Variables</th>
            <th className="note-col-2 x2 text-center">Case</th>
            <th className="note-col-2 x2 text-center">Status</th>
          </tr>
        </thead>
        <tbody id="table-body-cat" className="all_notes_tab fixed_column_width">
          {data &&
            data?.map((row, idx) => (
              <tr
                key={row.id}
                id={`row_${idx + 1}`}
                style={{ height: "45px" }}
                onClick={() => handleShowModal(row)}
              >
                <td className="td-autosize hover-button-td" style={{ textAlign: "left" }}>
                  {idx + 1}
                </td>
                <td className="td-autosize hover-button-td" style={{ textAlign: "center" }}>
                  {row?.for_text_source ? (
                    <>
                      <div>{row.for_text_source.name}</div>
                      <div>{formatPhoneNumber(row.for_text_source.phone_number)}</div>
                    </>
                  ) : row?.for_email_source ? (
                    <>
                      <div>{row.for_email_source.name}</div>
                      <div>{row.for_email_source.email}</div>
                      <div>{row.for_email_source.keywords || ""}</div>
                    </>
                  ) : (
                    <div>-</div>
                  )}
                </td>
                <td className="td-autosize hover-button-td" style={{ textAlign: "center" }}>
                  {formatDate(row?.date)}
                </td>
                <td className="td-autosize hover-button-td" style={{ textAlign: "center" }}>
                  {row?.subject ?? ""}
                </td>
                <td
                  className="client_page_note_row hover-button-td notes-sec-color-black"
                  style={{
                    textAlign: "left",
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                    // verticalAlign: "top",
                    paddingTop: "5px",
                    paddingBottom: "5px",
                  }}
                >
                  {row?.text}
                </td>
                <td
                  className="client_page_note_row hover-button-td notes-sec-color-black"
                  style={{
                    textAlign: "center",
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                    paddingTop: "5px",
                    paddingBottom: "5px",
                  }}
                >
                  <p style={{ paddingTop: "5px", paddingBottom: "5px" }}>
                    {row?.identified_variables &&
                      variableOrder?.length > 0 &&
                      Object.keys(row?.identified_variables).length > 0 && (
                        <p>
                          {variableOrder.map((key) => {
                            const value = row.identified_variables[key];
                            if (!(key in row.identified_variables)) return null;
                            return (
                              <p key={key}>
                                <span className="identify-leads-name">{key}</span>: {value}
                              </p>
                            );
                          })}
                        </p>
                      )}
                  </p>
                </td>
                <td className="td-autosize hover-button-td" style={{ textAlign: "center" }}>
                  {row?.for_client && row?.for_case && (
                    <>
                      <div
                        className="d-flex height-25 align-items-center "
                        style={{
                          // height: "25px",
                          color: "black",
                          fontWeight: "600",
                          gap: "5px",
                        }}
                      >
                        {row?.for_client?.profile_pic_19p ? (
                          <span className="ic-avatar ic-19 has-cover-img sidebar-pic">
                            <img
                              src={row?.for_client?.profile_pic_19p}
                              alt={row?.for_client?.first_name}
                            />
                          </span>
                        ) : (
                          <span className="ic ic-avatar ic-19 has-avatar-icon has-cover-img sidebar-pic" />
                        )}
                        {`${row?.for_client?.first_name},`} {row?.for_client?.last_name}
                      </div>
                      <div
                        className="d-flex height-25 align-items-center justify-content-start"
                        style={{
                          gap: "5px",
                        }}
                      >
                        <span className="d-flex align-items-center justify-content-center ic ic-19">
                          <img
                            src={birthdayIcon}
                            className="ic ic-19 d-flex align-items-center justify-content-center"
                          />
                        </span>
                        {formatCalendarDate(row.for_client?.birthday)},
                        <span
                          className="d-flex align-items-center justify-content-center"
                          style={{
                            color: "var(--primary)",
                          }}
                        >
                          Age
                        </span>
                        {getAge(row.for_client?.birthday)}
                      </div>
                      <div
                        style={{
                          gap: "5px",
                        }}
                        className="d-flex height-25 align-items-center justify-content-start"
                      >
                        <span className="d-flex align-items-center justify-content-center ic ic-19">
                          <img
                            src={row?.for_case.case_type?.casetype_icon}
                            className="ic ic-19 d-flex align-items-center justify-content-center"
                          />
                        </span>
                        {row?.for_case.case_type?.name}
                      </div>
                      <div
                        style={{
                          gap: "5px",
                        }}
                        className="d-flex height-25 align-items-center justify-content-start"
                      >
                        <span className="d-flex align-items-center justify-content-center ic ic-19">
                          <img
                            src={incidentIcon}
                            className="ic ic-19 d-flex align-items-center justify-content-center"
                          />
                        </span>
                        {formatCalendarDate(row.for_case.incident_date)}
                      </div>
                    </>
                  )}
                </td>
                <td className="td-autosize hover-button-td" style={{ textAlign: "center" }}>
                  {row?.status?.name}
                </td>
              </tr>
            ))}
        </tbody>
      </table>

      <LeadPopup
        show={showLeadModal}
        handleClose={handleCloseModal}
        editData={editData}
        setActiveTab={setActiveTab}
        setSubActiveTab={setSubActiveTab}
        fetchData={fetchData}
        PageName={"CreateClient"}
        fetchPendingData={fetchPendingData}
      />

      <PendingPopup
        show={showPendingModal}
        handleClose={handleCloseModalPending}
        message={pendingMessage}
        pendingUser={pendingUser}
        onConfirm={() => {
          setShowPendingModal(false);
          setShowLeadModal(true);
        }}
      />
    </>
  );
};

export default IncomingLeads;
